<template>

  <div>
    <kanban-board :title="value.steps[0].stepName" v-model="value.steps[0]" :stages="stages" />

    <kanban-board :title="value.steps[1].stepName" v-model="value.steps[1]" :stages="stages" />

    <kanban-board :title="value.steps[2].stepName" v-model="value.steps[2]" :stages="stages" />

    <kanban-board :title="value.steps[3].stepName" v-model="value.steps[3]" :stages="stages" />
  </div>

</template>

<script>
import PermitMixins from '@/mixins/PermitMixins'

import KanbanBoard from '@/components/atoms/KanbanBoard'
import KanbanCard from '@/components/atoms/KanbanCard'


export default {
  mixins: [PermitMixins],

  components: {
    KanbanBoard,
    KanbanCard,
  },

  props: {
    value: {
      type: Object,
      required: true
    },

    stages: {
      type: Array,
      default: function () {
        return ['pending', 'needs-review', 'in-progress', 'completed', 'approved']
      }
    },

  },

}

</script>

<style lang="scss" scoped>
  @import '../../assets/css/kanban.scss';

  $pending: #606266;
  $on-hold: #FB7D44;
  $needs-review: #E6A23C;
  $approved: #67C23A;
  $completed: #FB7D44;
  $in-progress: #409EFF;
  * {
    box-sizing: border-box;
  }
  body {
    background: #33363D;
    color: white;
    font-family: 'Raleway';
    font-weight: 300;
    line-height: 1.5;
    -webkit-font-smoothing: antialiased;
  }
  .drag-column {
    .drag-column-header > div {
      width: 100%;
      h2 > a {
        float: right;
      }
    }
    .drag-column-footer > div {
        margin-left: 10px;
        a {
            text-decoration: none;
            color: white;
            &:hover {
                text-decoration: underline;
            }
        }
    }
    &-pending {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $pending;
      }
    }
    &-on-hold {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $on-hold;
      }
    }
    &-in-progress {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $in-progress;
      }
    }
    &-needs-review {
      .drag-column-header,
      .is-moved,
      .drag-options{
        background: $needs-review;
      }
    }
    &-completed {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $completed;
      }
    }
    &-approved {
      .drag-column-header,
      .is-moved,
      .drag-options {
        background: $approved;
      }
    }
  }
  .section {
    padding: 20px;
    text-align: center;
    a {
      color: white;
      text-decoration: none;
      font-weight: 300;
    }
    h4 {
      font-weight: 400;
      a {
        font-weight: 600;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// ProgressSummary.vue?1f06536f